import { Controller } from "stimulus"

export default class extends Controller {
  
  static targets = [ "description", "counter" ]

  countCharacters() {
    let characters = this.descriptionTarget.value.length;
    this.counterTarget.innerText = characters;
    if (characters > 155) {
      this.counterTarget.classList.add('too-long')
    }
  }
}